import { render, staticRenderFns } from "./managers.vue?vue&type=template&id=3c3ed950&scoped=true&"
import script from "./managers.vue?vue&type=script&lang=js&"
export * from "./managers.vue?vue&type=script&lang=js&"
import style0 from "./managers.vue?vue&type=style&index=0&id=3c3ed950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ed950",
  null
  
)

export default component.exports